import React, { useState, useEffect } from 'react';
import { getBookingsByPoojari } from '../services/bookingService';

const DARK_RED = '#8B0000';
const GOLD = '#FFD700';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const formatDate = (iso) => {
    if (!iso) return '-';
    const d = new Date(iso);
    return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

const time12h = (t) => {
    if (!t) return '';
    const [h, m] = t.split(':');
    const hour = parseInt(h);
    const period = hour >= 12 ? 'PM' : 'AM';
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${h12}:${m} ${period}`;
};

/**
 * Poojari ki aane wali poojayein - Calendar tab ke liye.
 *
 * ⚠️ YE SECTION KYUN:
 *
 * Poojari ko ek hi jagah dekhna chahiye ki "main kab busy hoon".
 * Us mein do cheezein hain:
 *
 *   1. Jo poojayein book ho chuki hain (ye section)
 *   2. Jo din usne khud block kiye hain (CalendarBlockSection)
 *
 * Pehle ye do alag jagah the - bookings dashboard pe, blocked dates
 * profile mein. Poojari ko apna hafta dekhne ke liye do page kholne
 * padte the.
 *
 * ⚠️ YAHAN SIRF DIKHTA HAI, kuch kiya nahi ja sakta. Accept /
 *    complete / cancel sab "All Bookings" page pe hota hai. Do
 *    jagah wahi buttons rakhne se poojari confuse hota hai, aur
 *    galti se kuch daba dene ka khatra rehta hai.
 */
const UpcomingPoojasSection = ({ poojariId }) => {

    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!poojariId) return;

        let alive = true;
        setLoading(true);

        getBookingsByPoojari(poojariId)
            .then(data => {
                if (!alive) return;

                const list = Array.isArray(data) ? data : [];

                // ⚠️ Sirf AANE WALI confirmed poojayein.
                //
                //    PENDING chhod di - wo abhi accept hui hi nahi,
                //    aur calendar mein dikhane se poojari samajhta
                //    hai ki wo din pakka busy hai.
                //
                //    Purani tareekh bhi chhod di - calendar aage ka
                //    dekhne ke liye hai.
                const today = new Date().toISOString().split('T')[0];

                const upcoming = list
                    .filter(b => b.bookingStatus === 'CONFIRMED')
                    .filter(b => b.poojaDate >= today)
                    .sort((a, b) => {
                        // Nazdeek wali pehle
                        if (a.poojaDate !== b.poojaDate) {
                            return a.poojaDate < b.poojaDate ? -1 : 1;
                        }
                        return a.poojaTime < b.poojaTime ? -1 : 1;
                    });

                setBookings(upcoming);
            })
            .catch(() => {
                // ⚠️ Fail ho to khaali. Toast nahi - ye page ka
                //    mukhya kaam nahi hai.
                if (alive) setBookings([]);
            })
            .finally(() => {
                if (alive) setLoading(false);
            });

        return () => { alive = false; };
    }, [poojariId]);

    return (
        <div className="card mb-3"
            style={{
                borderRadius: '12px',
                border: `1px solid ${GOLD}`
            }}>
            <div className="card-body p-3">

                <p className="fw-bold mb-1"
                    style={{ color: DARK_RED, fontSize: '15px' }}>
                    Upcoming poojas
                </p>
                <p className="text-muted mb-3" style={{ fontSize: '12px' }}>
                    Days you are already booked
                </p>

                {loading ? (
                    <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                        Loading...
                    </p>
                ) : bookings.length === 0 ? (
                    <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                        No upcoming poojas.
                    </p>
                ) : (
                    bookings.map(b => (
                        <div key={b.id}
                            className="py-2"
                            style={{
                                borderLeft: '3px solid #2E7D32',
                                paddingLeft: '10px',
                                marginBottom: '8px'
                            }}>
                            <div style={{ fontSize: '13px', fontWeight: 600 }}>
                                {formatDate(b.poojaDate)}
                                {' · '}
                                {time12h(b.poojaTime)}
                            </div>
                            <div className="text-muted" style={{ fontSize: '12px' }}>
                                {b.poojaType}
                                {b.poojaCity && ` · ${b.poojaCity}`}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default UpcomingPoojasSection;